import { Temporal } from "@js-temporal/polyfill";
import React, { createContext, useContext } from "react";

const TemporalContext = createContext(Temporal);

export const TemporalProvider = ({ children }: { children: React.ReactNode }) => {
	return <TemporalContext.Provider value={Temporal}>{children}</TemporalContext.Provider>;
};

export const useTemporal = () => useContext(TemporalContext);
